import React, { useEffect, useState } from "react";
import Button from "../../../UI/Buttons/Button";
import { FaArrowLeft } from "react-icons/fa";
import { MdLocalActivity } from "react-icons/md";
import { StepsContainerStyled } from "../../../../styled/Resume";
import LanguageCard from "../../Tools/LanguageCard";
import { useTheme } from "../../../UI/Theme/ThemeContext";

const LanguageInfo = (props) => {
    const {
        step,
        setStep,
        setStepData,
        languages,
        handleLangChange,
        languageStore,
        langLevelsArray,
        handleDeleteLang,
        handleAddLang,
        langForwardOrBackward
    } = props;

    const [disableFields, setDisableFields] = useState(false);
    const { themeName } = useTheme();

    useEffect(() => {
        setStepData(prev => ({
            ...prev,
            languagesInfo: languages
        }));
    }, [languages, setStepData]);

    useEffect(() => {
        if (!languages || languages.length === 0) {
            setDisableFields(true); 
            return;
        }

        const isValid = languages.every(
            lang =>
                lang.language?.trim() !== "" &&
                lang.level?.trim() !== ""
        );
        setDisableFields(!isValid);
    }, [languages]);

    const handleClickForward = (e) => {
        if (e) e.preventDefault();
        langForwardOrBackward("forward");
        if (!disableFields) {
            setStep(step + 1);
        }
    };

    const handleClickBackward = (e) => {
        if (e) e.preventDefault();
        langForwardOrBackward("backward");
        setStep(step - 1);
    };

    return (
        <StepsContainerStyled theme={themeName}>
            <h2>Language Proficiency</h2>

            <LanguageCard
                languages={languages}
                handleLangChange={handleLangChange}
                languageStore={languageStore}
                langLevelsArray={langLevelsArray}
                handleDeleteLang={handleDeleteLang}
                handleAddLang={handleAddLang}
            />

            <div className={step > 1 ? "btnS" : "btn"}>
                <Button
                    justifycontent="start"
                    secondaryLight
                    width="100%"
                    clickHandle={handleClickBackward}
                >
                    <FaArrowLeft />
                    Previous
                </Button>
                    <div className="nextBtnWrap">
                        <Button
                            justifycontent="flex-end"
                            primary
                            width="100%"
                            clickHandle={handleClickForward}
                            disabled={disableFields}
                        >
                            Hobbies
                            <MdLocalActivity />
                        </Button>
                    </div>
            </div>
        </StepsContainerStyled>
    );
};

export default LanguageInfo;